import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import "./CAMDrawer.scss";
import { action } from "../../constants/action";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import AutoAwesomeMosaicOutlinedIcon from "@mui/icons-material/AutoAwesomeMosaicOutlined";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { investigatorRoutes } from "../../routes/routeConstants";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import OfflinePinOutlinedIcon from "@mui/icons-material/OfflinePinOutlined";

const CAMDrawer = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const {
    TASKSTATUS,
    AUDITTRAIL,
    SEARCH,
    VISUALIZATION,
    DATAPREVIEW,
    TASKSTATUSNEW,
    AUDITTRAILNEW,
    DATA_VALIDATION,
    MAPPING_VALIDATION,
  } = action;
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleListItemClick = (event, index, path) => {
    setSelectedIndex(index);
    navigate(path);
    console.log(selectedIndex);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div
      className="root"
      onMouseEnter={handleDrawerOpen}
      onMouseLeave={handleDrawerClose}
    >
      <Drawer
        variant="permanent"
        className={`drawer ${open ? "drawerOpen" : "drawerClose"}`}
        classes={{
          paper: `${open ? "drawerOpen" : "drawerClose"} drawer`,
        }}
        open={open}
      >
        <div>
          <List style={{ padding: "20px 5px" }}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    1,
                    `/${investigatorRoutes.taskStatus}`,
                  )
                }
                className={` list-item-button
                  ${
                    window.location.pathname ===
                    `/${investigatorRoutes.taskStatus}`
                      ? "list-item-button-selected"
                      : "list-item-button-not-selected"
                  }  `}
              >
                <ListItemIcon className="listItemIcon">
                  <AssignmentTurnedInOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={TASKSTATUS} />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(event, 3, `/${investigatorRoutes.logs}`)
                }
                className={` list-item-button
                  ${
                    window.location.pathname === `/${investigatorRoutes.logs}`
                      ? "list-item-button-selected"
                      : "list-item-button-not-selected"
                  }  `}
              >
                <ListItemIcon className="listItemIcon">
                  <ListAltOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={AUDITTRAIL} />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    4,
                    `/${investigatorRoutes.investigationAnalysis}`,
                  )
                }
                className={` list-item-button
                ${
                  window.location.pathname ===
                  `/${investigatorRoutes.investigationAnalysis}`
                    ? "list-item-button-selected"
                    : "list-item-button-not-selected"
                }  `}
              >
                <ListItemIcon className="listItemIcon">
                  <ZoomInOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={SEARCH} />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    5,
                    `/${investigatorRoutes.filesPreview}`,
                  )
                }
                className={` list-item-button
                  ${
                    window.location.pathname ===
                    `/${investigatorRoutes.filesPreview}`
                      ? "list-item-button-selected"
                      : "list-item-button-not-selected"
                  }  `}
              >
                <ListItemIcon className="listItemIcon">
                  <PreviewOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={DATAPREVIEW} />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    6,
                    `/${investigatorRoutes.visualizationInterface}`,
                  )
                }
                className={` list-item-button
                ${
                  window.location.pathname ===
                  `/${investigatorRoutes.visualizationInterface}`
                    ? "list-item-button-selected"
                    : "list-item-button-not-selected"
                }  `}
                disabled={true}
              >
                <ListItemIcon className="listItemIcon">
                  <AutoAwesomeMosaicOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={VISUALIZATION} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    7,
                    `/${investigatorRoutes.mappingValidation}`,
                  )
                }
                className={` list-item-button
                  ${
                    window.location.pathname ===
                    `/${investigatorRoutes.mappingValidation}`
                      ? "list-item-button-selected"
                      : "list-item-button-not-selected"
                  }  `}
                disabled={localStorage.getItem("userSubRoles") === '["viewer"]'}
              >
                <ListItemIcon className="listItemIcon">
                  <OfflinePinOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={MAPPING_VALIDATION} />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    8,
                    `/${investigatorRoutes.dataValidation}`,
                  )
                }
                className={` list-item-button
                  ${
                    window.location.pathname ===
                    `/${investigatorRoutes.dataValidation}`
                      ? "list-item-button-selected"
                      : "list-item-button-not-selected"
                  }  `}
              >
                <ListItemIcon className="listItemIcon">
                  <VerifiedOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={DATA_VALIDATION} />
              </ListItemButton>
            </ListItem>
          </List>
        </div>
      </Drawer>
    </div>
  );
};

export default CAMDrawer;
